/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// product page : tabs

// document.addEventListener("DOMContentLoaded", () => {
//   const collapsibleElements = document.querySelectorAll(".Collapsible__Button");

//   collapsibleElements.forEach((element) => {
//     element.addEventListener("click", (event) => {
//       const clickedButton = event.currentTarget; // The specific button clicked
//       const innerElement = clickedButton.nextElementSibling; // Assuming .Collapsible__Inner is the next sibling
//       const plusElement = clickedButton.querySelector(".Collapsible__Plus");
//       const mainCollapse = clickedButton.closest(".Collapsible--large"); // Closest parent with class `.Collapsible--large`

//       if (innerElement) {
//         innerElement.classList.toggle("inner-content");

//         if (innerElement.classList.contains("inner-content")) {
//           if (mainCollapse) {
//             mainCollapse.classList.remove("color_Collapsible");
//           }
//           if (plusElement) {
//             plusElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 24 24" style="fill:#1A1A1A;"><path fill-rule="evenodd" d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z"></path></svg>`;
//           }
//         } else {
//           if (mainCollapse) {
//             mainCollapse.classList.add("color_Collapsible");
//           }
//           if (plusElement) {
//             plusElement.innerHTML = `<svg class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M128 469.34016l768 0q17.67424 0 30.16704 12.4928t12.4928 30.16704-12.4928 30.16704-30.16704 12.4928l-768 0q-17.67424 0-30.16704-12.4928t-12.4928-30.16704 12.4928-30.16704 30.16704-12.4928z"  /></svg>`;
//           }
//         }
//       }
//     });
//   });
// });


function initCollapsible() {

  const collapsibleElements = document.querySelectorAll(".Collapsible__Button");

  collapsibleElements.forEach((element) => {

    element.removeEventListener("click", handleCollapse);
    element.addEventListener("click", handleCollapse);

  });

}

function handleCollapse(event) {

  const clickedButton = event.currentTarget;
  const innerElement = clickedButton.nextElementSibling;
  const plusElement = clickedButton.querySelector(".Collapsible__Plus");
  const mainCollapse = clickedButton.closest(".Collapsible--large");

  if (!innerElement) return;

  innerElement.classList.toggle("inner-content");

  if (innerElement.classList.contains("inner-content")) {

    mainCollapse?.classList.remove("color_Collapsible");

    plusElement.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 24 24" style="fill:#1A1A1A;"><path fill-rule="evenodd" d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z"></path></svg>
    `;

  } else {

    mainCollapse?.classList.add("color_Collapsible");

    plusElement.innerHTML = `
      <svg class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M128 469.34016l768 0q17.67424 0 30.16704 12.4928t12.4928 30.16704-12.4928 30.16704-30.16704 12.4928l-768 0q-17.67424 0-30.16704-12.4928t-12.4928-30.16704 12.4928-30.16704 30.16704-12.4928z"  /></svg>
    `;

  }
}

document.addEventListener("DOMContentLoaded", () => {
  initCollapsible();
});

// product page : color swatch
// document.addEventListener("DOMContentLoaded", function () {
//   var handle_urls = document.querySelectorAll(".a-metalink");
//   var color_value_element = document.querySelector(".span--color-name");
//   console.log("color_value_element", color_value_element);
//   var color_value = color_value_element
//     ? color_value_element.textContent
//     : null;

//   handle_urls.forEach(function (handle_url) {
//     var product_data = handle_url.getAttribute("data_product");
//     console.log("product_data", product_data);

//     if (color_value === product_data) {
//       handle_url.classList.add("selected_a");
//     } else {
//       handle_url.classList.remove("selected_a");
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  var handle_urls = document.querySelectorAll(".a-metalink");

  handle_urls.forEach(function (handle_url) {
    var product_data = handle_url.getAttribute("data_product");

    if (handle_url.classList.contains("selected_a")) {
      var parentSection = handle_url.closest(".main--color-margin");
      var color_value_element = parentSection.querySelector(".span--color-name");
      color_value_element.textContent = product_data;
    }
  });
});





// science page tabs
$(document).on("click", ".plus_icon_click", function () {
  $(this)
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .find(".click_show_column")
    .slideToggle();
  $(this)
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .toggleClass("content-show-column-active");
});
$(document).on("click", ".plus_icon_click_tgl", function () {
  $(this)
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .find(".text-block-tgl .shg-default-text-content ")
    .slideToggle();
  $(this)
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .toggleClass("content-show-tgl-active");
});

// header sidebar drawer

$(document).ready(function () {
  $(".sub-btn").click(function () {
    $(this).next(".sub-menu").slideToggle();
    $(this).find(".dropdown").toggleClass("rotate");
    $(this).find(".minus_drawer-icons").toggleClass("menu_minus");
    $("body").addClass("hide-overflow");
  });

  $(".sidebar_hamburger").click(function () {
    $(".side-bar").addClass("active");
    $(".page-overlay").fadeIn(); // Show overlay
    $("body").addClass("hide-overflow");
  });

  $(".close-btn, .page-overlay").click(function () {
    $(".side-bar").removeClass("active");
    $(".page-overlay").fadeOut();
    $("body").removeClass("hide-overflow");
  });
});

window.onscroll = function () {
  var scrollPosition = window.scrollY || document.documentElement.scrollTop;

  // Check if scroll is more than 50px
  if (scrollPosition > 50) {
    document.querySelector(".side-bar").style.top = "0";
    console.log("Screen size is greater than 50px (0)");
  } else {
    document.querySelector(".side-bar").style.top = "";
    console.log("Screen size is less than 50px (-45)");
  }
};

// header sidebar Toggle child menu on click when there is grandchild
$(".menu .item .has_childlink").click(function () {
  $(this).next(".sub-menu").slideToggle();
  $(this).find(".dropdown").toggleClass("rotate");
  $(this).find(".minus_drawer-icons").toggle();
});
